import { useState, useEffect } from 'react';
import { API_CONFIG } from './../config'; 

const FETCH_USERS = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USERDATA}`;

const useUsersData = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(FETCH_USERS);
                if (!response.ok) throw new Error('Network response was not ok');
                
                const data = await response.json();
                if (data.success) {
                    setUsers(data.data || []);
                } 
            } catch (err) {
                console.error("Fetch users error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // Returning data and loading state just like your book example
    return { users, loading };
};

export default useUsersData;